import $ from 'jquery';
import Cookies from 'js-cookie';
import metaContent from '../fn/metaContent';
import html from 'rails-plus/es6/modules/html';

const supported_locales = ['en', 'ru'];

const translations = {
  'en': {
    text: 'You can view this website in english',
    label: 'View in english',
  },
  'ru': {
    text: 'Вы можете перейти на русскую версию сайта',
    label: 'Перейти на русскую версию',
  }
};

const flash = (locale, finalURL) => html`
  <div class="flash-item flash-item_info flash-item_buttoned">
    <div class="flash-item__body flash-item__body_info">
      <div class="flash-item__close" />
      ${translations[locale].text}
      <a href="${finalURL}" class="button h-30px button_white">
        ${translations[locale].label}
      </a>
    </div>
  </div>
`;

const init = () => {
  const cookie = Cookies.get('locale_selected');
  if (cookie) { return; }
  Cookies.set('locale_selected', true, { expires: 20 * 365 });
  const language = navigator.language;
  if (!language) { return; }
  const browserLocale = language.replace(/-.+/g, '');
  if (!supported_locales.includes(browserLocale)) { return; }
  const selectedLocale = Cookies.get('locale');
  if (browserLocale === selectedLocale) { return; }

  const dirtyURL = metaContent('specialLocalizedURL');
  const finalURL = dirtyURL.replace('undefinedLocale', browserLocale);
  $('#flashes').append(flash(browserLocale, finalURL));
};

const start = () => {
  document.addEventListener('DOMContentLoaded', init);
};

export default { init, start };
